// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoPlayer_videoContainer__64oDP","video":"VideoPlayer_video__Y9L3m"};